<button 
    type="button" 
    class="sg-btn sg-social-btn"
    [class.-facebook]="social === 'facebook'"
    [class.-google]="social === 'google'"
><img [src]="path + social + '.svg'" class="sg-social-btn__img"> {{ label }}</button>
